/**
 * AgentForge boot — suite OAuth hash tokens, Binder query handoff, skins + motion.
 */

import { applyTokensFromHash } from "./suite/auth";
import { bootstrapTheme } from "./themes/applyTheme";
import { bootstrapBgFx } from "./themes/bgFx";
import { consumeBinderQuery } from "./lib/endpoint";

let didBoot = false;

export function bootstrapAgentForge(): void {
  if (didBoot) return;
  didBoot = true;
  try {
    applyTokensFromHash();
  } catch {
    /* ignore */
  }
  try {
    consumeBinderQuery();
  } catch {
    /* ignore */
  }
  try {
    bootstrapTheme();
    bootstrapBgFx();
  } catch {
    /* ignore */
  }
}
